import Vue from 'vue';
import store from '@/store';
import VueRouter, { RouteConfig } from 'vue-router';
import Manual from '@/views/HomePage/ManualList/index.vue';
import Home from '../views/HomePage/index.vue';
import Login from '../views/LoginPage/index.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        path: '/manual',
        name: 'Manual',
        component: Manual,
      },
    ],
    meta: {
      requiresAuth: true,
    },
    redirect: {
      path: '/manual',
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    beforeEnter: (to, from, next) => {
      if (store.getters['auth/isLogged']) {
        next('/');
      } else {
        next();
      }
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // catch page if required authorization
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters['auth/isLogged']) {
      next();
      return;
    }
    next('/login');
  } else {
    next();
  }
});

export default router;
